import { CountryCode } from '@payer-admin-ui/api/src/invoices/models/CountryCode';
import { CurrencyCode } from '@payer-admin-ui/api/src/invoices/models/CurrencyCode';
import { LanguageCode } from '@payer-admin-ui/api/src/invoices/models/LanguageCode';
import { CreatePaymentRequestRequest } from '@payer-admin-ui/api/src/paymentrequests/requests/CreatePaymentRequestRequest';
import { CreatePaymentRequestResponse } from '@payer-admin-ui/api/src/paymentrequests/responses/CreatePaymentRequestResponse';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { paymentRequestAPI } from '../../../redux/paymentRequestAPI';

export const createPaymentRequest = createAsyncThunk<CreatePaymentRequestResponse, CreatePaymentRequestRequest>(
  'paymentrequests/CreatePaymentRequestPage/createPaymentRequest',
  async (requestBody, { dispatch }) => {
    return paymentRequestAPI.createPaymentRequest(requestBody);
  },
);

export type CreatePaymentRequestDraft = {
  amount: number;
  currencyCode: CurrencyCode;
  countryCode: CountryCode;
  languageCode: LanguageCode;
  externalPaymentReference: string;
};

export type CreatePaymentRequestPageState = {
  draft: CreatePaymentRequestDraft;
  isFetching: boolean;
  success: boolean;
  error: any;
  response?: CreatePaymentRequestResponse;
};

export const initialCreatePaymentRequest: CreatePaymentRequestDraft = {
  amount: 0,
  currencyCode: CurrencyCode.SEK,
  countryCode: CountryCode.SE,
  languageCode: LanguageCode.sv,
  externalPaymentReference: '',
};

const initialState: CreatePaymentRequestPageState = {
  draft: initialCreatePaymentRequest,
  isFetching: false,
  success: false,
  error: null,
  response: undefined,
};

const createPaymentRequestPageSlice = createSlice({
  name: 'paymentrequests/CreatePaymentRequestPage',
  initialState,
  reducers: {
    reset: () => ({ ...initialState }),
    resetError: state => {
      state.error = null;
    },
    patchDraft: (state, { payload }: PayloadAction<Partial<CreatePaymentRequestDraft>>) => {
      state.draft = { ...state.draft, ...payload };
    },
  },
  extraReducers: builder => {
    builder.addCase(createPaymentRequest.pending, state => ({
      ...state,
      isFetching: true,
      success: false,
      error: null,
    }));
    builder.addCase(createPaymentRequest.fulfilled, (state, { payload: response }) => ({
      ...state,
      isFetching: false,
      success: true,
      error: null,
      response,
    }));
    builder.addCase(createPaymentRequest.rejected, (state, { error }) => ({
      ...state,
      isFetching: false,
      success: false,
      error,
      response: undefined,
    }));
  },
});

export const {
  actions: { reset, resetError, patchDraft },
  reducer: createPaymentRequestPageReducer,
} = createPaymentRequestPageSlice;
